// @ts-ignore
import gql from "graphql-tag";

// @ts-ignore
import { Maybe, Fragment, Query, Mutation } from "base-types";

export type EmptyObject = "EMPTY" | "FUTURE_VALUE";
export type EmptyObjectKnownValue = "EMPTY";
export const EmptyObjectKnownValues: EmptyObjectKnownValue[] = [ "EMPTY" ];
export type CustomerEnvironment = "PRODUCTION" | "TEST" | "FUTURE_VALUE";
export type CustomerEnvironmentKnownValue = "PRODUCTION" | "TEST";
export const CustomerEnvironmentKnownValues: CustomerEnvironmentKnownValue[] = [ "PRODUCTION","TEST" ];
export type CountryCode = "AF" | "AL" | "DZ" | "AS" | "AD" | "AO" | "AI" | "AQ" | "AG" | "AR" | "AM" | "AW" | "AU" | "AT" | "AZ" | "BS" | "BH" | "BD" | "BB" | "BY" | "BE" | "BZ" | "BJ" | "BM" | "BT" | "BO" | "BA" | "BW" | "BV" | "BR" | "IO" | "BN" | "BG" | "BF" | "BI" | "KH" | "CM" | "CA" | "CV" | "KY" | "CF" | "TD" | "CL" | "CN" | "CX" | "CC" | "CO" | "KM" | "CG" | "CD" | "CK" | "CR" | "CI" | "HR" | "CU" | "CY" | "CZ" | "DK" | "DJ" | "DM" | "DO" | "EC" | "EG" | "SV" | "GQ" | "ER" | "EE" | "ET" | "FK" | "FO" | "FJ" | "FI" | "FR" | "GF" | "PF" | "TF" | "GA" | "GM" | "GE" | "DE" | "GH" | "GI" | "GR" | "GL" | "GD" | "GP" | "GU" | "GT" | "GN" | "GW" | "GY" | "HT" | "HM" | "VA" | "HN" | "HK" | "HU" | "IS" | "IN" | "ID" | "IR" | "IQ" | "IE" | "IL" | "IT" | "JM" | "JP" | "JO" | "KZ" | "KE" | "KI" | "KP" | "KR" | "KW" | "KG" | "LA" | "LV" | "LB" | "LS" | "LR" | "LY" | "LI" | "LT" | "LU" | "MO" | "MG" | "MW" | "MY" | "MV" | "ML" | "MT" | "MH" | "MQ" | "MR" | "MU" | "YT" | "MX" | "FM" | "MD" | "MC" | "MN" | "MS" | "MA" | "MZ" | "MM" | "NA" | "NR" | "NP" | "NL" | "NC" | "NZ" | "NI" | "NE" | "NG" | "NU" | "NF" | "MK" | "MP" | "NO" | "OM" | "PK" | "PW" | "PS" | "PA" | "PG" | "PY" | "PE" | "PH" | "PN" | "PL" | "PT" | "PR" | "QA" | "RE" | "RO" | "RU" | "RW" | "SH" | "KN" | "LC" | "PM" | "VC" | "WS" | "SM" | "ST" | "SA" | "SN" | "SC" | "SL" | "SG" | "SK" | "SI" | "SB" | "SO" | "ZA" | "GS" | "ES" | "LK" | "SD" | "SR" | "SJ" | "SZ" | "SE" | "CH" | "SY" | "TW" | "TJ" | "TZ" | "TH" | "TL" | "TG" | "TK" | "TO" | "TT" | "TN" | "TR" | "TM" | "TC" | "TV" | "UG" | "UA" | "AE" | "GB" | "US" | "UM" | "UY" | "UZ" | "VU" | "VE" | "VN" | "VG" | "VI" | "WF" | "EH" | "YE" | "ZM" | "ZW" | "AX" | "BQ" | "CW" | "GG" | "IM" | "JE" | "ME" | "BL" | "MF" | "RS" | "SX" | "SS" | "XK" | "FUTURE_VALUE";
export type CountryCodeKnownValue = "AF" | "AL" | "DZ" | "AS" | "AD" | "AO" | "AI" | "AQ" | "AG" | "AR" | "AM" | "AW" | "AU" | "AT" | "AZ" | "BS" | "BH" | "BD" | "BB" | "BY" | "BE" | "BZ" | "BJ" | "BM" | "BT" | "BO" | "BA" | "BW" | "BV" | "BR" | "IO" | "BN" | "BG" | "BF" | "BI" | "KH" | "CM" | "CA" | "CV" | "KY" | "CF" | "TD" | "CL" | "CN" | "CX" | "CC" | "CO" | "KM" | "CG" | "CD" | "CK" | "CR" | "CI" | "HR" | "CU" | "CY" | "CZ" | "DK" | "DJ" | "DM" | "DO" | "EC" | "EG" | "SV" | "GQ" | "ER" | "EE" | "ET" | "FK" | "FO" | "FJ" | "FI" | "FR" | "GF" | "PF" | "TF" | "GA" | "GM" | "GE" | "DE" | "GH" | "GI" | "GR" | "GL" | "GD" | "GP" | "GU" | "GT" | "GN" | "GW" | "GY" | "HT" | "HM" | "VA" | "HN" | "HK" | "HU" | "IS" | "IN" | "ID" | "IR" | "IQ" | "IE" | "IL" | "IT" | "JM" | "JP" | "JO" | "KZ" | "KE" | "KI" | "KP" | "KR" | "KW" | "KG" | "LA" | "LV" | "LB" | "LS" | "LR" | "LY" | "LI" | "LT" | "LU" | "MO" | "MG" | "MW" | "MY" | "MV" | "ML" | "MT" | "MH" | "MQ" | "MR" | "MU" | "YT" | "MX" | "FM" | "MD" | "MC" | "MN" | "MS" | "MA" | "MZ" | "MM" | "NA" | "NR" | "NP" | "NL" | "NC" | "NZ" | "NI" | "NE" | "NG" | "NU" | "NF" | "MK" | "MP" | "NO" | "OM" | "PK" | "PW" | "PS" | "PA" | "PG" | "PY" | "PE" | "PH" | "PN" | "PL" | "PT" | "PR" | "QA" | "RE" | "RO" | "RU" | "RW" | "SH" | "KN" | "LC" | "PM" | "VC" | "WS" | "SM" | "ST" | "SA" | "SN" | "SC" | "SL" | "SG" | "SK" | "SI" | "SB" | "SO" | "ZA" | "GS" | "ES" | "LK" | "SD" | "SR" | "SJ" | "SZ" | "SE" | "CH" | "SY" | "TW" | "TJ" | "TZ" | "TH" | "TL" | "TG" | "TK" | "TO" | "TT" | "TN" | "TR" | "TM" | "TC" | "TV" | "UG" | "UA" | "AE" | "GB" | "US" | "UM" | "UY" | "UZ" | "VU" | "VE" | "VN" | "VG" | "VI" | "WF" | "EH" | "YE" | "ZM" | "ZW" | "AX" | "BQ" | "CW" | "GG" | "IM" | "JE" | "ME" | "BL" | "MF" | "RS" | "SX" | "SS" | "XK";
export const CountryCodeKnownValues: CountryCodeKnownValue[] = [ "AF","AL","DZ","AS","AD","AO","AI","AQ","AG","AR","AM","AW","AU","AT","AZ","BS","BH","BD","BB","BY","BE","BZ","BJ","BM","BT","BO","BA","BW","BV","BR","IO","BN","BG","BF","BI","KH","CM","CA","CV","KY","CF","TD","CL","CN","CX","CC","CO","KM","CG","CD","CK","CR","CI","HR","CU","CY","CZ","DK","DJ","DM","DO","EC","EG","SV","GQ","ER","EE","ET","FK","FO","FJ","FI","FR","GF","PF","TF","GA","GM","GE","DE","GH","GI","GR","GL","GD","GP","GU","GT","GN","GW","GY","HT","HM","VA","HN","HK","HU","IS","IN","ID","IR","IQ","IE","IL","IT","JM","JP","JO","KZ","KE","KI","KP","KR","KW","KG","LA","LV","LB","LS","LR","LY","LI","LT","LU","MO","MG","MW","MY","MV","ML","MT","MH","MQ","MR","MU","YT","MX","FM","MD","MC","MN","MS","MA","MZ","MM","NA","NR","NP","NL","NC","NZ","NI","NE","NG","NU","NF","MK","MP","NO","OM","PK","PW","PS","PA","PG","PY","PE","PH","PN","PL","PT","PR","QA","RE","RO","RU","RW","SH","KN","LC","PM","VC","WS","SM","ST","SA","SN","SC","SL","SG","SK","SI","SB","SO","ZA","GS","ES","LK","SD","SR","SJ","SZ","SE","CH","SY","TW","TJ","TZ","TH","TL","TG","TK","TO","TT","TN","TR","TM","TC","TV","UG","UA","AE","GB","US","UM","UY","UZ","VU","VE","VN","VG","VI","WF","EH","YE","ZM","ZW","AX","BQ","CW","GG","IM","JE","ME","BL","MF","RS","SX","SS","XK" ];
export type SupportedLocale = "FRENCH" | "ENGLISH" | "FUTURE_VALUE";
export type SupportedLocaleKnownValue = "FRENCH" | "ENGLISH";
export const SupportedLocaleKnownValues: SupportedLocaleKnownValue[] = [ "FRENCH","ENGLISH" ];
export type NablaProduct = "ASSISTANT" | "CORE_API" | "FUTURE_VALUE";
export type NablaProductKnownValue = "ASSISTANT" | "CORE_API";
export const NablaProductKnownValues: NablaProductKnownValue[] = [ "ASSISTANT","CORE_API" ];
export type IdentityKind = "COPILOT_ASSISTANT_USER" | "COPILOT_API_DEVELOPER" | "FUTURE_VALUE";
export type IdentityKindKnownValue = "COPILOT_ASSISTANT_USER" | "COPILOT_API_DEVELOPER";
export const IdentityKindKnownValues: IdentityKindKnownValue[] = [ "COPILOT_ASSISTANT_USER","COPILOT_API_DEVELOPER" ];
export type LoginMethod = "PASSWORD_WITHOUT_MFA" | "PASSWORD_WITH_MFA" | "ONE_TIME_TOKEN_WITHOUT_MFA" | "ONE_TIME_TOKEN_WITH_MFA" | "EPIC_SSO" | "CERNER_SSO" | "ATHENA_SSO" | "REDROVER_SSO" | "MEDITECH_SSO" | "SAML_SSO" | "INITIAL_CREATION" | "ORGANIZATION_INITIATED" | "ASSISTANT_USER_INITIATED_LOW_PRIVILEGE" | "NABLA_CONNECT_ONE_TIME_CODE" | "FUTURE_VALUE";
export type LoginMethodKnownValue = "PASSWORD_WITHOUT_MFA" | "PASSWORD_WITH_MFA" | "ONE_TIME_TOKEN_WITHOUT_MFA" | "ONE_TIME_TOKEN_WITH_MFA" | "EPIC_SSO" | "CERNER_SSO" | "ATHENA_SSO" | "REDROVER_SSO" | "MEDITECH_SSO" | "SAML_SSO" | "INITIAL_CREATION" | "ORGANIZATION_INITIATED" | "ASSISTANT_USER_INITIATED_LOW_PRIVILEGE" | "NABLA_CONNECT_ONE_TIME_CODE";
export const LoginMethodKnownValues: LoginMethodKnownValue[] = [ "PASSWORD_WITHOUT_MFA","PASSWORD_WITH_MFA","ONE_TIME_TOKEN_WITHOUT_MFA","ONE_TIME_TOKEN_WITH_MFA","EPIC_SSO","CERNER_SSO","ATHENA_SSO","REDROVER_SSO","MEDITECH_SSO","SAML_SSO","INITIAL_CREATION","ORGANIZATION_INITIATED","ASSISTANT_USER_INITIATED_LOW_PRIVILEGE","NABLA_CONNECT_ONE_TIME_CODE" ];
export type MfaMethodKind = "TOTP" | "FUTURE_VALUE";
export type MfaMethodKindKnownValue = "TOTP";
export const MfaMethodKindKnownValues: MfaMethodKindKnownValue[] = [ "TOTP" ];
export type NablaRegion = "EU" | "US" | "FUTURE_VALUE";
export type NablaRegionKnownValue = "EU" | "US";
export const NablaRegionKnownValues: NablaRegionKnownValue[] = [ "EU","US" ];
export type CloudRegion = "EU_WEST1" | "US_CENTRAL1" | "FUTURE_VALUE";
export type CloudRegionKnownValue = "EU_WEST1" | "US_CENTRAL1";
export const CloudRegionKnownValues: CloudRegionKnownValue[] = [ "EU_WEST1","US_CENTRAL1" ];



export type CopilotApiOrganizationInput = {
  id: string;
  displayName: string;
  locale: SupportedLocale;
  timezone: TimeZone;
  alpha2CountryCode: CountryCode;
  attributionData?: Maybe<string>;
  customerEnvironment?: Maybe<CustomerEnvironment>
}
export type InitialCopilotApiDeveloperIdentityInput = { _?: Maybe<EmptyObject> }
export type SetupMfaInput = { code: string; methodKind: MfaMethodKind }

export const possibleTypes: { [key in keyof PossibleTypes]: PossibleTypes[key][] } = {
  "Identity": [
    "CopilotAssistantUserIdentity",
    "CopilotApiDeveloperIdentity"
  ],
  "MfaState": [
    "NotSetupMfaState",
    "SetupMfaState"
  ],
  "MfaMethod": [
    "TotpMfaMethod"
  ]
};
export type PossibleTypes = {
  Identity: ("CopilotAssistantUserIdentity" | "CopilotApiDeveloperIdentity")
  MfaState: ("NotSetupMfaState" | "SetupMfaState")
  MfaMethod: ("TotpMfaMethod")
};

export type EntityName = 
  | "Account"
  | "CopilotAssistantUserIdentity"
  | "CopilotApiDeveloperIdentity"
  | "CopilotAssistantUser"
  | "CopilotApiDeveloper"
  | "Organization"
export type EntityFieldMap = {
  Account: "uuid" | "email" | "locale" | "timezone" | "identities" | "hasPassword" | "mfaState";
  CopilotAssistantUserIdentity: "uuid" | "kind" | "user" | "acceptableLoginMethods";
  CopilotApiDeveloperIdentity: "uuid" | "kind" | "developer" | "acceptableLoginMethods";
  CopilotAssistantUser: "uuid" | "organization" | "canAccessOrganizationUserApi";
  CopilotApiDeveloper: "uuid" | "organization";
  Organization: "uuid" | "stringId" | "displayName" | "product" | "customerEnvironment"
}
export type QueryVariablesMap = {  }

export type QueryName = 
  | "AccountIdentities"

const AccountOrganizationSummaryFragmentDocument = gql`
fragment AccountOrganizationSummary on Organization {
  uuid
  displayName
  stringId
  product
  customerEnvironment
}

`
export const AccountOrganizationSummaryFragmentProps: Fragment<AccountOrganizationSummaryFragment> = {
  document: AccountOrganizationSummaryFragmentDocument,
  fragmentName: "AccountOrganizationSummary",
  entityName: "Organization",
  __do_not_use_Data: null
}
export type AccountOrganizationSummaryFragment = {
  __typename: "Organization";
  uuid: UUID;
  displayName: string;
  stringId: string;
  product: NablaProduct;
  customerEnvironment: CustomerEnvironment
}

const CopilotApiDeveloperSummaryFragmentDocument = gql`
fragment CopilotApiDeveloperSummary on CopilotApiDeveloper {
  uuid
  organization {
    ...AccountOrganizationSummary
  }
}
${AccountOrganizationSummaryFragmentDocument}
`
export const CopilotApiDeveloperSummaryFragmentProps: Fragment<CopilotApiDeveloperSummaryFragment> = {
  document: CopilotApiDeveloperSummaryFragmentDocument,
  fragmentName: "CopilotApiDeveloperSummary",
  entityName: "CopilotApiDeveloper",
  __do_not_use_Data: null
}
export type CopilotApiDeveloperSummaryFragment = { __typename: "CopilotApiDeveloper"; uuid: UUID; organization: AccountOrganizationSummaryFragment }

const IdentityFragmentDocument = gql`
fragment Identity on Identity {
  uuid
  acceptableLoginMethods
  ... on CopilotApiDeveloperIdentity {
    developer {
      ...CopilotApiDeveloperSummary
    }
  }
}
${CopilotApiDeveloperSummaryFragmentDocument}
`
export const IdentityFragmentProps: Fragment<IdentityFragment> = {
  document: IdentityFragmentDocument,
  fragmentName: "Identity",
  entityName: "Identity",
  __do_not_use_Data: null
}
export type IdentityFragment = { uuid: UUID; acceptableLoginMethods: Array<LoginMethod> }&({ __typename: "CopilotApiDeveloperIdentity"; developer: CopilotApiDeveloperSummaryFragment } | { __typename: "FutureValue" })

const IdentitiesFragmentDocument = gql`
fragment Identities on Account {
  uuid
  identities {
    ...Identity
  }
}
${IdentityFragmentDocument}
`
export const IdentitiesFragmentProps: Fragment<IdentitiesFragment> = {
  document: IdentitiesFragmentDocument,
  fragmentName: "Identities",
  entityName: "Account",
  __do_not_use_Data: null
}
export type IdentitiesFragment = { __typename: "Account"; uuid: UUID; identities: Array<IdentityFragment> }

export type AccountIdentitiesData = IdentitiesFragment&{ email: EmailAddress; locale: SupportedLocale; timezone: TimeZone; hasPassword: boolean; mfaState: ({ __typename: "SetupMfaState"; supportedMethods: Array<({ __typename: "TotpMfaMethod"; isSetup: boolean } | { __typename: "FutureValue" })> } | { __typename: "NotSetupMfaState"; supportedMethods: Array<({ __typename: "TotpMfaMethod"; isSetup: boolean; tentativeQrCode: string } | { __typename: "FutureValue" })> } | { __typename: "FutureValue" }) }
export type AccountIdentitiesVariables = { [key: string]: never }
export const AccountIdentities: Query<AccountIdentitiesData, AccountIdentitiesVariables, false, "ACCOUNT"> = {
  schemaType: "ACCOUNT",
  document: gql`
query AccountIdentities {
  me {
    ...Identities
    email
    locale
    timezone
    hasPassword
    mfaState {
      ... on SetupMfaState {
        supportedMethods {
          ... on TotpMfaMethod {
            isSetup
          }
        }
      }
      ... on NotSetupMfaState {
        supportedMethods {
          ... on TotpMfaMethod {
            isSetup
            tentativeQrCode
          }
        }
      }
    }
  }
}
${IdentitiesFragmentDocument}
`,
  __do_not_use_Data: null,
  __do_not_use_Variables: null,
  __do_not_use_VariablesRequired: null
}

export type CreateCopilotApiOrganizationData = { __typename: "CreateCopilotApiOrganizationOutput"; organization: { __typename: "Organization"; uuid: UUID }; initialIdentity: { __typename: "CopilotApiDeveloperIdentity"; uuid: UUID; acceptableLoginMethods: Array<LoginMethod>; developer: CopilotApiDeveloperSummaryFragment } }
export type CreateCopilotApiOrganizationVariables = { organizationInput: CopilotApiOrganizationInput; initialIdentityInput: InitialCopilotApiDeveloperIdentityInput }
export const CreateCopilotApiOrganization: Mutation<CreateCopilotApiOrganizationData, CreateCopilotApiOrganizationVariables, "ACCOUNT"> = {
  schemaType: "ACCOUNT",
  document: gql`
mutation CreateCopilotApiOrganization($organizationInput: CopilotApiOrganizationInput!, $initialIdentityInput: InitialCopilotApiDeveloperIdentityInput!) {
  createCopilotApiOrganization(
    organization: $organizationInput
    initialIdentity: $initialIdentityInput
  ) {
    organization {
      uuid
    }
    initialIdentity {
      uuid
      acceptableLoginMethods
      developer {
        ...CopilotApiDeveloperSummary
      }
    }
  }
}
${CopilotApiDeveloperSummaryFragmentDocument}
`,
  endpointName: "createCopilotApiOrganization",
  updateInputsPaths: [],
  __do_not_use_Data: null,
  __do_not_use_Variables: null
}

export type ChooseAccountCredentialsAuthenticatedData = { __typename: "ChooseAccountCredentialsOutput"; jwtTokens: { __typename: "JWTTokens"; accessToken: string; refreshToken: string } }
export type ChooseAccountCredentialsAuthenticatedVariables = { newPassword: string; verifyMfaCode?: Maybe<string> }
export const ChooseAccountCredentialsAuthenticated: Mutation<ChooseAccountCredentialsAuthenticatedData, ChooseAccountCredentialsAuthenticatedVariables, "ACCOUNT"> = {
  schemaType: "ACCOUNT",
  document: gql`
mutation ChooseAccountCredentialsAuthenticated($newPassword: String!, $verifyMfaCode: String) {
  chooseAccountCredentials(
    mfa: {verify: {code: $verifyMfaCode}}
    newPassword: $newPassword
  ) {
    jwtTokens {
      accessToken
      refreshToken
    }
  }
}

`,
  endpointName: "chooseAccountCredentials",
  updateInputsPaths: [],
  __do_not_use_Data: null,
  __do_not_use_Variables: null
}

export type SetupMfaMethodData = { __typename: "SetupMfaMethodOutput"; jwtTokens: { __typename: "JWTTokens"; accessToken: string; refreshToken: string } }
export type SetupMfaMethodVariables = { mfaCode?: Maybe<string>; newMethod: SetupMfaInput }
export const SetupMfaMethod: Mutation<SetupMfaMethodData, SetupMfaMethodVariables, "ACCOUNT"> = {
  schemaType: "ACCOUNT",
  document: gql`
mutation SetupMfaMethod($mfaCode: String, $newMethod: SetupMfaInput!) {
  setupMfaMethod(mfaCode: $mfaCode, newMethod: $newMethod) {
    jwtTokens {
      accessToken
      refreshToken
    }
  }
}

`,
  endpointName: "setupMfaMethod",
  updateInputsPaths: [],
  __do_not_use_Data: null,
  __do_not_use_Variables: null
}